// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1AOnE","addWidgetButton":"Header_addWidgetButton__hwBR8","dashboardTabs":"Header_dashboardTabs__1ZMMs","active":"Header_active__iidW7"};